import React from "react";
import { Button } from "../components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "../components/ui/card";
import { getAuthUrl } from "../api";

const LoginPage = () => {
  const handleLogin = () => {
    window.location.href = getAuthUrl();
  };

  return (
    <div className="container max-w-md mx-auto">
      <div className="mt-8 flex flex-col items-center">
        <Card className="w-full">
          <CardHeader>
            <CardTitle className="text-center">
              Bitbucket Variable Manager
            </CardTitle>
            <CardDescription className="text-center">
              Manage your Bitbucket repository variables in bulk
            </CardDescription>
          </CardHeader>
          <CardContent className="flex justify-center">
            <Button size="lg" onClick={handleLogin}>
              Login with Bitbucket
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default LoginPage;
